/**
 * Route gate. Anything nested under it needs a staff session.
 *
 * This is convenience, not security: the API re-checks the staff token on every
 * request and would reject an unauthenticated call regardless of what the
 * router let render. What it buys is that a signed-out person sees the login
 * screen instead of a shell full of failed requests.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAdminAuth } from './AuthProvider';

export interface RedirectState {
  /** Where to return to once signed in. */
  readonly from?: string;
}

export function RequireAdmin() {
  const { admin } = useAdminAuth();
  const location = useLocation();

  if (admin === null) {
    const state: RedirectState = { from: `${location.pathname}${location.search}` };
    return <Navigate to="/login" replace state={state} />;
  }

  return <Outlet />;
}
